/* eslint-disable jsx-a11y/anchor-is-valid, jsx-quotes */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { checkIfMobile } from '../../ducks/reducers';
import { Covid19BannerWrapper, Image, Link, TextContent, } from './Covid19Banner.styles';

const imageSrc =
  'https://assets.fastly.carvana.io/about-assets/exclamation-icon.png';

const DesktopBannerText = (
  <>
    <Image src={imageSrc} />
    <TextContent>
      <span className="is-bold">COVID-19 information</span>&nbsp;Touchless
      delivery/pickup is currently underway in your area.
      <Link href="/touchless-delivery"> Learn More</Link>
    </TextContent>
  </>

);

const MobileBannerText = (
  <TextContent>
    Safe, touchless delivery &amp; pickup.
    <Link href="/touchless-delivery"> Learn More &gt;</Link>
  </TextContent>
);

const Covid19Banner = ({ isMobile }) => {
  return (
    <Covid19BannerWrapper>
      {isMobile ? MobileBannerText : DesktopBannerText}
    </Covid19BannerWrapper>
  );
};

Covid19Banner.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isMobile: checkIfMobile(state),
});

export default connect(mapStateToProps)(Covid19Banner);
